import constraints from '../../constraints';
import getExtensionControlsForElement from '../../extensions/helpers/get-extension-controls-for-element';

const isSelectableElement = (element) => {
  if (constraints.verifiers.canBeInteracted(element)) {
    if (constraints.verifiers.canBeSelected(element)) {
      return true;
    }

    return false;
  }

  const extensionControls = getExtensionControlsForElement(element);
  if (extensionControls.length) {
    return true;
  }

  return false;
};

export default isSelectableElement;
